module.exports = __webpack_public_path__ + "img/19_59.94fd628c.png";